// declaration mensuelles
 
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'; // Import de useLocation pour récupérer l'ID
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import axios from 'axios';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import '../CSS/DéclarationsMensuelles.css';
import Menu from './Menu'; // Import du menu
import apiUrl from '../config';
import Snackbar from '@mui/material/Snackbar'; // Pour les notifications
import Alert from '@mui/material/Alert'; // Pour le style des notifications
import Dialog from '@mui/material/Dialog'; // Pour la boîte de dialogue
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { CircularProgress } from '@mui/material';




const DeclarationsMensuellesPage = () => {
  const [selectedWorkDates, setSelectedWorkDates] = useState([]);
  const [selectedLeaveDates, setSelectedLeaveDates] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [hours, setHours] = useState('');
  const [declarations, setDeclarations] = useState([]);
  const [editingDeclaration, setEditingDeclaration] = useState(null);
  const [baseWorkDates, setBaseWorkDates] = useState([]);
  const [baseLeaveDates, setBaseLeaveDates] = useState([]);
  const [isBaseDatesLoaded, setIsBaseDatesLoaded] = useState(false);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const [hasLoadedBaseDates, setHasLoadedBaseDates] = useState(false);
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false); // Contrôle de la boîte de dialogue
  const [declarationToDelete, setDeclarationToDelete] = useState(null); // ID de la déclaration à supprimer
  const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' }); // Notifications
  const [loading, setLoading] = useState(false);  // Pour gérer le chargement des déclarations pour l'utilisateur normal
  const [loadingAdmin, setLoadingAdmin] = useState(false);  // Pour gérer le chargement des déclarations pour l'admin
  const [currentUserId, setCurrentUserId] = useState(null);
  const location = useLocation(); // Récupérer l'état transmis par navigate (ID de l'utilisateur)
  const [loadingSelection, setLoadingSelection] = useState(false); // Nouveau state pour gérer le chargement lors de la sélection
  




// La fonction useEffect est utilisée pour effectuer des effets de bord après le rendu du composant. Elle vérifie d'abord s'il y a un token d'authentification dans le stockage local. Si c'est le cas, elle décode ce token pour obtenir les informations de l'utilisateur et déterminer son rôle (admin ou non). Si l'utilisateur est un administrateur (admin), elle charge la liste des utilisateurs avec la fonction fetchUsers(). Ensuite, elle charge les déclarations de l'utilisateur en cours (selon son user_id).

useEffect(() => {
  const token = localStorage.getItem('token');
  
  if (!token) {
    navigate('/login'); // Redirige si l'utilisateur n'est pas authentifié
  } else {
    const decodedToken = JSON.parse(atob(token.split('.')[1]));
    setIsAdmin(decodedToken.role === 'admin');
    setCurrentUserId(decodedToken.user_id); // Définir l'ID de l'utilisateur connecté

    // Vérifie si un ID utilisateur est passé depuis la page Profil (admin ou non)
    const userIdFromProfile = location.state?.userId;

    if (userIdFromProfile) {
      // Si un ID utilisateur est passé dans l'état, c'est probablement un admin qui a sélectionné un utilisateur spécifique
      setSelectedUser(userIdFromProfile);
      setLoadingSelection(true); // ✅ Active l'affichage du message "Merci de patienter"
      fetchDeclarations(userIdFromProfile).catch(() => {
        setLoadingSelection(false);
        setNotification({
          open: true,
          message: 'Erreur lors du chargement des déclarations.',
          severity: 'error',
        });
      });
    } else {
      // Si aucun ID utilisateur passé, par défaut on prend celui de l'utilisateur connecté (normal)
      if (decodedToken.role !== 'admin') {
        // Utilisateur normal : on force la sélection sur l'utilisateur connecté uniquement
        setSelectedUser(decodedToken.user_id); 
        setLoadingSelection(true); // ✅ Active avant chargement
        fetchDeclarations(decodedToken.user_id)
          .then(() => setLoadingSelection(false)) // ✅ Désactive après chargement
          .catch(() => {
            setNotification({
              open: true,
              message: 'Erreur lors du chargement des déclarations.',
              severity: 'error',
            });
          });
      } else {
        // Administrateur : peut voir les déclarations des autres utilisateurs
        const storedSelectedUser = localStorage.getItem('selectedUser');
        if (storedSelectedUser) {
          setSelectedUser(storedSelectedUser); // Définit l'utilisateur par défaut
          setLoadingSelection(true); // ✅ Active le message avant chargement
          fetchDeclarations(storedSelectedUser)
            .then(() => setLoadingSelection(false)) // ✅ Désactive après chargement
            .catch(() => {
              setLoadingSelection(false);
              setNotification({
                open: true,
                message: 'Erreur lors du chargement des déclarations.',
                severity: 'error',
              });
            });
        } else {
          setSelectedUser(decodedToken.user_id); 
          setLoadingSelection(true); // ✅ Active avant chargement
          fetchDeclarations(decodedToken.user_id)
            .then(() => setLoadingSelection(false)) // ✅ Désactive après chargement
            .catch(() => {
              setNotification({
                open: true,
                message: 'Erreur lors du chargement des déclarations.',
                severity: 'error',
              });
            });
        }
      }
    }

    // Si c'est un admin, on charge la liste des utilisateurs
    if (decodedToken.role === 'admin') {
      setLoadingAdmin(true); // On démarre le chargement pour l'admin
      fetchUsers().catch(() => {
        setNotification({
          open: true,
          message: 'Erreur lors du chargement des utilisateurs.',
          severity: 'error',
        });
      });
    }
  }
}, [navigate, location.state?.userId]);


// Cette fonction effectue une requête HTTP GET pour récupérer la liste des utilisateurs (CDI) à partir de l'API. Elle utilise l'authentification avec un Bearer token qui est stocké dans le localStorage. Si la requête réussit, les utilisateurs sont stockés dans l'état users.

  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${apiUrl}/cdi-users`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      setUsers(response.data);
    } catch (error) {
      console.error('Erreur lors du chargement des utilisateurs:', error);
    }
  };


  const isWeekend = (date) => {
    const day = date.getDay(); // 0 = dimanche, 6 = samedi
    return day === 0 || day === 6; // Retourne vrai si c'est un samedi ou un dimanche
  };
  

// Cette fonction effectue une requête HTTP GET pour récupérer les déclarations d'un utilisateur spécifique. Le userId de l'utilisateur est passé dans l'URL de la requête pour cibler les déclarations de cet utilisateur particulier. Les déclarations obtenues sont stockées dans l'état declarations. 

const fetchDeclarations = async (userId) => {
  setLoading(true); // Démarre le chargement
  setLoadingAdmin(true);  // Démarre le chargement pour les admins
  setLoadingSelection(true); // ✅ Active "Merci de patienter..."
  
  try {
    const response = await axios.get(`${apiUrl}/declarations/${userId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });

    setDeclarations(response.data);
    
    if (response.data.length > 0) {
      setLoadingSelection(false); // ✅ Désactive une fois le tableau rempli
    } else {
      setTimeout(() => setLoadingSelection(false), 2000); // ✅ Ajoute un léger délai pour éviter un clignotement
    }

  } catch (error) {
    console.error('Erreur lors du chargement des déclarations:', error);
    setLoadingSelection(false); // ✅ Désactive même en cas d'erreur
  } finally {
    setLoading(false); // Arrête le chargement
    setLoadingAdmin(false); // Arrête le chargement admin
  }
};



  //  Cette fonction gère la sélection ou la désélection des dates (de travail ou de congé). Elle prend une date et l'ajoute ou la retire de la liste des dates sélectionnées (selectedDates) en fonction de si la date est déjà présente ou non.

  const toggleDateSelection = (date, selectedDates, setSelectedDates) => {
    setSelectedDates((prevSelected) => {
      const isSelected = prevSelected.some(
        (selectedDate) =>
          selectedDate.getFullYear() === date.getFullYear() &&
          selectedDate.getMonth() === date.getMonth() &&
          selectedDate.getDate() === date.getDate()
      );
  
      // Si la date est déjà sélectionnée, on la retire
      if (isSelected) {
        return prevSelected.filter(
          (selectedDate) =>
            selectedDate.getFullYear() !== date.getFullYear() ||
            selectedDate.getMonth() !== date.getMonth() ||
            selectedDate.getDate() !== date.getDate()
        );
      } else {
        // Sinon, on l'ajoute
        return [...prevSelected, date];
      }
    });
  };

  // Fonction pour calculer les jours fériés français
const getFrenchHolidays = (year) => {
  // Calcul des jours fixes
  const holidays = [
    new Date(`${year}-01-01`), // Nouvel An
    new Date(`${year}-05-01`), // Fête du Travail
    new Date(`${year}-05-08`), // Victoire 1945
    new Date(`${year}-07-14`), // Fête Nationale
    new Date(`${year}-08-15`), // Assomption
    new Date(`${year}-11-01`), // Toussaint
    new Date(`${year}-11-11`), // Armistice
    new Date(`${year}-12-25`), // Noël
  ];

  // Calcul de Pâques
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;

  // Ajout de Pâques et jours dérivés
  const easter = new Date(year, month - 1, day);
  holidays.push(new Date(easter)); // Dimanche de Pâques
  holidays.push(new Date(easter.getTime() + 1 * 24 * 60 * 60 * 1000)); // Lundi de Pâques
  holidays.push(new Date(easter.getTime() + 50 * 24 * 60 * 60 * 1000)); // Lundi de Pentecôte

  return holidays;
};


const isHoliday = (date) => {
  const year = date.getFullYear(); // Obtenir l'année de la date
  const holidays = getFrenchHolidays(year); // Générer les jours fériés pour cette année
  return holidays.some(
    (holiday) =>
      date.getFullYear() === holiday.getFullYear() &&
      date.getMonth() === holiday.getMonth() &&
      date.getDate() === holiday.getDate()
  );
};


  // Ces deux fonctions sont des gestionnaires d'événements pour les clics sur les jours du calendrier. handleWorkDayClick est utilisé pour sélectionner ou désélectionner un jour de travail. handleLeaveDayClick est utilisé pour sélectionner ou désélectionner un jour de congé.
  
  const handleWorkDayClick = (date) => {
    toggleDateSelection(date, selectedWorkDates, setSelectedWorkDates, baseWorkDates);
  };
  
  const handleLeaveDayClick = (date) => {
    toggleDateSelection(date, selectedLeaveDates, setSelectedLeaveDates);
  };
  

// La fonction handleSubmit est appelée lors de la soumission du formulaire pour envoyer les jours de travail et de congé à l'API. Elle formate les dates de travail et de congé en chaînes ISO et les envoie via une requête POST avec un payload contenant ces dates et les heures saisies. Elle recharge ensuite les déclarations après avoir soumis avec succès.

  const handleSubmit = async () => {
    const formattedWorkDates = selectedWorkDates
      .filter(date => date instanceof Date && !isNaN(date))  // Vérifier que la date est valide
      .map(date => new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0]);
  
    const formattedLeaveDates = selectedLeaveDates
      .filter(date => date instanceof Date && !isNaN(date))  // Vérifier que la date est valide
      .map(date => new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0]);
  
    try {
      const token = localStorage.getItem('token');
      const payload = {
        workDays: formattedWorkDates,
        leaveDays: formattedLeaveDates,
        hours: hours || undefined,
        Id_Utilisateur: isAdmin ? selectedUser : undefined,
      };
  
      const response = await axios.post(`${apiUrl}/declarations`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setNotification({ open: true, message: 'Déclaration ajoutée avec succès.', severity: 'success' });
      setDeclarations([...declarations, response.data]); // Mettre à jour l'état avec la nouvelle déclaration
      await fetchDeclarations(isAdmin ? selectedUser : JSON.parse(atob(token.split('.')[1])).user_id);
      // Réinitialiser les dates sélectionnées
      setSelectedWorkDates([]);
      setSelectedLeaveDates([]);
    } catch (error) {
      console.error('Erreur lors de la déclaration des jours:', error);
      setNotification({ open: true, message: 'Erreur lors de l\'ajout de la déclaration.', severity: 'error' });
    }
  };
  
// Cette fonction récupère les détails d'une déclaration spécifique pour la modifier. Elle obtient les jours de travail et de congé, les formate et les charge dans l'état. Elle met aussi à jour l'état editingDeclaration pour afficher le formulaire de modification avec les données existantes.

  const handleEdit = async (declarationId) => {
    try {
      const response = await axios.get(`${apiUrl}/declarations/details/${declarationId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      const workDates = response.data.Jours_Selectionnes.split("/").map(dateStr => new Date(dateStr.trim()));
      const leaveDates = response.data.jours_congé.split("/").map(dateStr => new Date(dateStr.trim()));
  
      setBaseWorkDates(workDates);
      setBaseLeaveDates(leaveDates);
  
      if (!hasLoadedBaseDates) {
        setSelectedWorkDates([...workDates]);
        setSelectedLeaveDates([...leaveDates]);
        setHasLoadedBaseDates(true);
      }
  
      setEditingDeclaration({ Id_Declaration: declarationId, ...response.data });
    } catch (error) {
      console.error('Erreur lors de la récupération de la déclaration:', error);
    }
  };
  
// Cette fonction est appelée lorsqu'une déclaration existante doit être mise à jour. Elle vérifie si des dates de travail ou de congé ont été modifiées, puis envoie les nouvelles dates à l'API avec les heures et l'ID de l'utilisateur.

  const handleUpdate = async () => {
    if (editingDeclaration) {
      const finalWorkDates = selectedWorkDates.filter(date =>
        !baseWorkDates.some(baseDate => baseDate.getTime() === date.getTime()) || selectedWorkDates.includes(date)
      );
      
      const finalLeaveDates = selectedLeaveDates.filter(date =>
        !baseLeaveDates.some(baseDate => baseDate.getTime() === date.getTime()) || selectedLeaveDates.includes(date)
      );
  
      const formattedWorkDates = finalWorkDates
        .filter(date => date instanceof Date && !isNaN(date))  // Vérifier que la date est valide
        .map(date => new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0]);
  
      const formattedLeaveDates = finalLeaveDates
        .filter(date => date instanceof Date && !isNaN(date))  // Vérifier que la date est valide
        .map(date => new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0]);
  
      if (formattedWorkDates.length === 0 && formattedLeaveDates.length === 0) {
        setNotification({
          open: true,
          message: 'Veuillez sélectionner au moins une date de travail ou de congé.',
          severity: 'error',
        });      
        return;
      }
  
      try {
        const token = localStorage.getItem('token');
        const payload = {
          Id_Declaration: editingDeclaration.Id_Declaration,
          workDays: formattedWorkDates.length > 0 ? formattedWorkDates : undefined,
          leaveDays: formattedLeaveDates.length > 0 ? formattedLeaveDates : undefined,
          hours: hours || undefined,
          Id_Utilisateur: isAdmin ? selectedUser : undefined,
        };
  
        const response = await axios.put(`${apiUrl}/declarations/${editingDeclaration.Id_Declaration}`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  
        setNotification({ open: true, message: 'Déclaration modifiée avec succès.', severity: 'success' });
        setDeclarations(declarations.map(decl =>
          decl.Id_Declaration === editingDeclaration.Id_Declaration ? response.data : decl ));
        // Réinitialiser les dates sélectionnées
        setSelectedWorkDates([]);
        setSelectedLeaveDates([]);  
        setEditingDeclaration(null);
        await fetchDeclarations(isAdmin ? selectedUser : JSON.parse(atob(token.split('.')[1])).user_id);

      } catch (error) {
        console.error('Erreur lors de la validation des modifications:', error);
        setNotification({ open: true, message: 'Erreur lors de la modification de la déclaration.', severity: 'error' });
      }
    }
  };
  

// Cette fonction permet de supprimer une déclaration existante. Elle demande une confirmation avant de procéder à la suppression, puis envoie une requête DELETE à l'API pour supprimer la déclaration.

  const handleDelete = (declarationId) => {
    setDeclarationToDelete(declarationId); // Stocke l'ID de la déclaration
    setOpenDialog(true); // Ouvre la boîte de dialogue
};
  
const handleConfirmDelete = async () => {
  try {
      const token = localStorage.getItem('token');
      await axios.delete(`${apiUrl}/declarations/${declarationToDelete}`, {
          headers: {
              Authorization: `Bearer ${token}`,
          },
      });
      setNotification({ open: true, message: 'Déclaration supprimée avec succès.', severity: 'success' });
      setDeclarations(declarations.filter(decl => decl.Id_Declaration !== declarationToDelete)); // Retirer de l'état
      setDeclarationToDelete(null); // Réinitialise l'ID
      setOpenDialog(false); // Fermer la boîte de dialogue
  } catch (error) {
      console.error('Erreur lors de la suppression de la déclaration:', error);
      setNotification({ open: true, message: 'Erreur lors de la suppression de la déclaration.', severity: 'error' });
  }
};




  //Cette fonction prend une chaîne de dates séparées par des slashes (/) et les formate dans un format jour/mois/année. 

  const formatDates = (datesString) => {
    if (!datesString) return 'Aucun';
    return datesString
      .split('/')
      .map(date => {
        const [year, month, day] = date.trim().split('-');
        return `${day}/${month}/${year}`;
      })
      .join(', ');
  };

  // Cette fonction retourne le nom du mois à partir des dates de travail ou de congé, en fonction de celles qui sont disponibles. Elle prend en compte à la fois les jours de travail et de congé.

  const getMonthName = (workDatesString, leaveDatesString) => {
    // Vérifier si les jours de travail ou de congé sont présents
    const workDates = workDatesString ? workDatesString.split('/').map(date => new Date(date.trim())) : [];
    const leaveDates = leaveDatesString ? leaveDatesString.split('/').map(date => new Date(date.trim())) : [];
  
    // Si des jours de travail sont présents, retourner le mois de travail
    if (workDates.length > 0) {
      const monthIndex = workDates[0].getMonth(); // Prendre le mois de la première date de travail
      const monthNames = [
        'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 
        'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
      ];
      return monthNames[monthIndex];
    } 
  
    // Sinon, si des jours de congé sont présents, retourner le mois de congé
    if (leaveDates.length > 0) {
      const monthIndex = leaveDates[0].getMonth(); // Prendre le mois de la première date de congé
      const monthNames = [
        'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 
        'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
      ];
      return monthNames[monthIndex];
    }
  
    return 'Non spécifié'; // Si aucune date n'est trouvée, renvoyer "Non spécifié"
  };
  
// Ces deux fonctions vérifient si une date spécifique fait partie des jours sélectionnés pour les jours de travail ou de congé. Elles sont utilisées dans le calendrier pour appliquer un style différent aux jours sélectionnés.

  const isWorkSelected = (date) => {
    return selectedWorkDates.some((selectedDate) => 
      date.getFullYear() === selectedDate.getFullYear() &&
      date.getMonth() === selectedDate.getMonth() &&
      date.getDate() === selectedDate.getDate()
    );
};

const isLeaveSelected = (date) => {
    return selectedLeaveDates.some((selectedDate) => 
      date.getFullYear() === selectedDate.getFullYear() &&
      date.getMonth() === selectedDate.getMonth() &&
      date.getDate() === selectedDate.getDate()
    );
};
  
  return (
    <div className="declarations-container">
      <Menu /> {/* Menu fixe intégré */}
      {/* En-tête avec titre */}
         <div className="header">
                    <Typography variant="h1" gutterBottom align="center" sx={{ color: '#1f6391' }}>Déclaration des jours de travail et de congé</Typography>
                </div>
      
      <Container maxWidth="lg" sx={{ p: 3 }} className="content">
       
     
        <Box sx={{ mt: 4 }}>

        {isAdmin && (
  <>
    <TextField
      select
      label="Choisir un utilisateur CDI"
      value={selectedUser}
      onChange={(e) => {
        setSelectedUser(e.target.value);
        localStorage.setItem('selectedUser', e.target.value);
        setLoadingAdmin(true);
        setLoadingSelection(true);
        fetchDeclarations(e.target.value)
          .then(() => setLoadingSelection(false))
          .catch(() => {
            setLoadingSelection(false);
            setNotification({
              open: true,
              message: 'Erreur lors du chargement des déclarations.',
              severity: 'error',
            });
          });
      }}
      fullWidth
      margin="normal"
      variant="outlined"
    >
      {users.map((user) => (
        <MenuItem key={user.id} value={user.id}>
          {user.nom} {user.prenom}
        </MenuItem>
      ))}
    </TextField>

    {/* ✅ Bien inclus dans le bloc conditionnel */}
    {loadingSelection && (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mt: 2,
        }}
      >
        <Snackbar
          open={loadingSelection}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          autoHideDuration={null}
        >
          <Alert
            severity="info"
            sx={{ width: '100%', fontSize: '1rem', fontWeight: 'bold', textAlign: 'center' }}
          >
            
            Merci de patienter...
          </Alert>
        </Snackbar>
      </Box>
    )}
  </>
)}



          <Typography variant="h6" gutterBottom sx={{ color: '#1f6391' }}>
            Sélectionnez les jours de travail :
          </Typography>

{/* Calendriers pour sélectionner les jours de travail et de congé : Deux calendriers sont affichés pour permettre à l'utilisateur de sélectionner ses jours de travail et de congé.
Le calendrier utilise le composant Calendar et applique un style personnalisé aux jours sélectionnés : */}
         <Calendar
  onClickDay={handleWorkDayClick}
  tileClassName={({ date }) => {
    if (
      isHoliday(date) &&
      selectedWorkDates.some(
        (selectedDate) =>
          date.getFullYear() === selectedDate.getFullYear() &&
          date.getMonth() === selectedDate.getMonth() &&
          date.getDate() === selectedDate.getDate()
      )
    ) {
      return 'holiday-selected'; // Jour férié sélectionné
    } else if (isHoliday(date)) {
      return 'holiday'; // Jour férié non sélectionné
    } else if (
      selectedWorkDates.some(
        (selectedDate) =>
          date.getFullYear() === selectedDate.getFullYear() &&
          date.getMonth() === selectedDate.getMonth() &&
          date.getDate() === selectedDate.getDate()
      )
    ) {
      return 'highlight-work'; // Jour de travail sélectionné
    } else if (
      baseWorkDates.some(
        (baseDate) =>
          date.getFullYear() === baseDate.getFullYear() &&
          date.getMonth() === baseDate.getMonth() &&
          date.getDate() === baseDate.getDate()
      )
    ) {
      return 'highlight-base'; // Jour de base
    } else if (isWeekend(date)) {
      return 'weekend'; // Week-end non sélectionné
    }
    return '';
  }}
/>




<Typography variant="h6" gutterBottom sx={{ mt: 4, color: '#1f6391' }}>
            Sélectionnez les jours de congé (optionnel) :
          </Typography>

          <Calendar
  onClickDay={handleLeaveDayClick}
  tileClassName={({ date }) => {
    if (
      isHoliday(date) &&
      selectedLeaveDates.some(
        (selectedDate) =>
          date.getFullYear() === selectedDate.getFullYear() &&
          date.getMonth() === selectedDate.getMonth() &&
          date.getDate() === selectedDate.getDate()
      )
    ) {
      return 'holiday-selected'; // Jour férié sélectionné
    } else if (isHoliday(date)) {
      return 'holiday'; // Jour férié non sélectionné
    } else if (
      selectedLeaveDates.some(
        (selectedDate) =>
          date.getFullYear() === selectedDate.getFullYear() &&
          date.getMonth() === selectedDate.getMonth() &&
          date.getDate() === selectedDate.getDate()
      )
    ) {
      return 'highlight-leave'; // Jour de congé sélectionné
    } else if (isWeekend(date)) {
      return 'weekend'; // Week-end non sélectionné
    }
    return '';
  }}
/>



{/* Champ pour entrer le nombre d'heures (optionnel) : Un champ de texte permet à l'utilisateur d'entrer un nombre d'heures de travail. */}
          <TextField
            label="Nombre d'heures (optionnel)"
            type="number"
            value={hours}
            onChange={(e) => setHours(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
            margin="normal"
            variant="outlined"
          />
{/* Bouton pour soumettre ou modifier la déclaration : Le bouton pour soumettre la déclaration ou enregistrer les modifications dépend si l'utilisateur est en mode édition. */}
          <Button variant="contained" sx={{  bgcolor: '#1f6391', color: 'white', mt: 2 }} onClick={editingDeclaration ? handleUpdate : handleSubmit}>
            {editingDeclaration ? 'Enregistrer les modifications' : 'Soumettre'}
          </Button>

          <Box sx={{ mt: 4 }}>
            <Typography variant="h5" component="h2" gutterBottom sx={{ color: '#1f6391' }}>
              Déclarations
            </Typography>

            <TableContainer component={Paper} sx={{ bgcolor: '#1f6391', borderRadius: '8px' }}>

              {/* Tableau des déclarations : Les déclarations sont affichées dans un tableau avec des colonnes telles que le mois, les dates de travail, les dates de congé, etc. Le mois affiché dans la colonne Le Mois dépend des dates de travail ou de congé disponibles, en utilisant la fonction getMonthName. */}
              <Table>
                <TableHead sx={{ bgcolor: '#1f6391' }}>
                  <TableRow>
                    <TableCell sx={{ color: 'white' }}>Le Mois</TableCell>
                    <TableCell sx={{ color: 'white' }}>Date Déclarations</TableCell>
                    <TableCell sx={{ color: 'white' }}>Jours de travail</TableCell>
                    <TableCell sx={{ color: 'white' }}>Jours de congé</TableCell>
                    <TableCell sx={{ color: 'white' }}>Somme de Jours de travail</TableCell>
                    <TableCell sx={{ color: 'white' }}>Somme de Jours Congé</TableCell>
                    <TableCell sx={{ color: 'white' }}>Modifier</TableCell>
                    <TableCell sx={{ color: 'white' }}>Supprimer</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {declarations.map((declaration) => (
                    <TableRow key={declaration.Id_Declaration}>
                      <TableCell>{getMonthName(declaration.Jours_Selectionnes, declaration.jours_congé)}</TableCell>
                      <TableCell>{formatDates(declaration.Date)}</TableCell>
                      <TableCell>{formatDates(declaration.Jours_Selectionnes)}</TableCell>
                      <TableCell>{formatDates(declaration.jours_congé)}</TableCell>
                      <TableCell>{declaration.Somme_Jours || '0'}</TableCell>
                      <TableCell>{declaration.Total_Jours_Congé || '0'}</TableCell>
                      <TableCell>
                      <Button variant="outlined" sx={{ color: '#2980b9',  }} onClick={() => handleEdit(declaration.Id_Declaration)}>Modifier</Button>
                      </TableCell>
                      <TableCell>
                      <Button variant="outlined" sx={{ color: '#2980b9' }} onClick={() => handleDelete(declaration.Id_Declaration)} > Supprimer </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {!isAdmin && loading &&  (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      mt: 2,  // Espace entre le tableau et le message de chargement
    }}
  >
    <Snackbar
      open={loading}  // Affiche le message uniquement quand 'loading' est vrai
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={null}  // Le message de chargement restera visible pendant le chargement
    >
      <Alert severity="info" sx={{ width: '100%', fontSize: '1rem', fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        
        Merci de patienter...
      </Alert>
    </Snackbar>
  </Box>
)}


          </Box>
{/* Section pour modifier une déclaration existante : Si une déclaration est en mode édition, un formulaire de modification est affiché. */}
          {editingDeclaration && (
            <Box sx={{ mt: 4 }}>
              <Typography variant="h6" component="h2" gutterBottom sx={{ color: '#1f6391' }}>
                Modifier la déclaration
              </Typography>
            </Box>
          )}
        </Box>
      </Container>
      <Snackbar
    open={notification.open}
    autoHideDuration={3000}
    onClose={() => setNotification({ ...notification, open: false })}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
    <Alert severity={notification.severity} sx={{ width: '100%' }}>
        {notification.message}
    </Alert>
</Snackbar>

<Dialog
    open={openDialog}
    onClose={() => setOpenDialog(false)}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
>
    <DialogTitle id="alert-dialog-title" sx={{ textAlign: 'center', fontWeight: 'bold', color: '#1f6391' }}>
        Confirmation de suppression
    </DialogTitle>
    <DialogContent>
        <Typography id="alert-dialog-description" sx={{ textAlign: 'center', fontSize: '1.2rem' }}>
            Êtes-vous sûr de vouloir supprimer cette déclaration ?
        </Typography>
    </DialogContent>
    <DialogActions sx={{ justifyContent: 'center', gap: '1rem' }}>
        <Button
            onClick={() => setOpenDialog(false)} // Annuler l'action
            variant="outlined"
            sx={{ color: '#1f6391', borderColor: '#1f6391' }}
        >
            Annuler
        </Button>
        <Button
            onClick={handleConfirmDelete} // Confirmer la suppression
            variant="contained"
            sx={{ bgcolor: '#1f6391', color: 'white' }}
        >
            Confirmer
        </Button>
    </DialogActions>
</Dialog>

<Snackbar
    open={notification.open}
    autoHideDuration={3000}
    onClose={() => setNotification({ ...notification, open: false })}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
    <Alert severity={notification.severity} sx={{ width: '100%', fontWeight: 'bold', textAlign: 'center' }}>
        {notification.message}
    </Alert>
</Snackbar>

    </div>
  );
};

export default DeclarationsMensuellesPage;


